import React from 'react';
import { LaosMarketSection } from '../components/LaosMarketSection';
export function LaosMarketPage() {
  return <div className="pt-20" data-id="element-802">
      <LaosMarketSection data-id="element-803" />
    </div>;
}